/**
 * Picks, among a mark's client rects, the anchor rect for its note
 * marker: the top-most rect that intersects the visible band.
 * A mark spanning a column/page break yields rects outside the visible band
 * (e.g. in the previous column); those are discarded so the marker never
 * lands on a non-visible page. When the band carries vertical bounds
 * (EPUB scroll mode), fragments scrolled out of the viewport are discarded
 * too, so an offscreen note never emits an anchor.
 * @param {Array<{left: number, right: number, top: number, bottom?: number}>} rects - Client rects of the mark fragments
 * @param {{left: number, right: number, top?: number, bottom?: number}} visibleBand - Bounds of the visible reading area; vertical bounds are optional and applied only when present
 * @returns {{left: number, right: number, top: number}|null} The anchor rect, or null when no fragment is visible
 */
export function findVisibleAnchorRect(rects, visibleBand) {
    if (!rects?.length || !visibleBand) return null;

    const hasVerticalBand = Number.isFinite(visibleBand.top) && Number.isFinite(visibleBand.bottom);
    const visibleRects = Array.from(rects).filter(
        rect =>
            rect.right > visibleBand.left &&
            rect.left < visibleBand.right &&
            (!hasVerticalBand || ((rect.bottom ?? rect.top) > visibleBand.top && rect.top < visibleBand.bottom))
    );
    if (!visibleRects.length) return null;

    return visibleRects.reduce((topMostRect, rect) => (rect.top < topMostRect.top ? rect : topMostRect));
}
